import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { post } from '@/lib/api-client';
import { Card, ErrorNote, Field, InfoNote, SubmitButton } from '@/components/Form';

/** [FR-M01.8] Second leg of recovery — code plus new password. */
export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const identifier = params.get('identifier') ?? '';
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await post<void>('/auth/password/reset', { identifier, code, password }, { auth: false });
      navigate('/login', { state: { passwordReset: true } });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Could not reset the password');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card title="Choose a new password" subtitle={`Resetting the account for ${identifier}`}>
        <ErrorNote message={error} />
        <InfoNote>Resetting your password signs you out of every device.</InfoNote>

        <Field
          label="Reset code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          inputMode="numeric"
          maxLength={6}
          required
        />
        <Field
          label="New password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          hint="At least 12 characters"
          required
        />
        <SubmitButton busy={busy}>Reset password</SubmitButton>
      </Card>
    </form>
  );
}
